export default __webpack_public_path__ + "static/media/001-chef hat.1da35169.svg";